/* usage:
  <side-panel
    name='mypanel'
    alignment='left' <- 'left' or 'right'
    custom-panel-class = 'max-w-[375px]
  >
    ...your content
  </side-panel>
*/
 
export default class SidePanel extends HTMLElement {

  connectedCallback() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.alignment = this.attributes.alignment.value || 'left';
    this.name = this.attributes.name.value;
    this.customPanelClass = this.attributes['custom-panel-class']?.value || 'max-w-panel'
    this.overlay = document.createElement('div');
    this.menu = document.querySelectorAll('[data-header-mega-menu]');
    
    // eslint-disable-next-line max-len
    this.overlay.classList.add(
      'bg-black',
      'fixed',
      'top-0',
      'right-0',
      'bottom-0',
      'left-0',
      'w-full',
      'h-full',
      'z-[9997]',
      'opacity-75',
      'cursor-pointer'
    );

    this.staticAlignmentClass = this.alignment === 'left' ? 'left-0' : 'right-0';
    this.translateClass = this.alignment === 'left' ? '-translate-x-full' : 'translate-x-full';

    // eslint-disable-next-line max-len
    this.classList.add(
      'block', 
      this.customPanelClass,
      'w-full',
      'fixed',
      'top-0',
      'bottom-0',
      'z-[99998]',
      'bg-white',
      this.staticAlignmentClass,
      this.translateClass, // TODO: make this variable so panel can be on either side
      'duration-500'
    );

    this.style.display = '';

    setTimeout(() => {
      this.classList.add('transition-transform');
    }, 100);

    document.addEventListener(`open-panel:${this.name}`, this.open);
    document.addEventListener(`close-panel:${this.name}`, this.close);
    document.addEventListener(`close-all-panels`, this.close);
  }
    
  disconnectedCallback() {
    document.removeEventListener(`open-panel:${this.name}`, this.open);
    document.removeEventListener(`close-panel:${this.name}`, this.close);
    document.removeEventListener(`close-all-panels`, this.close);
  }

  open(e) {
    e.stopPropagation();
    this.classList.remove(this.translateClass);
    this.parentNode.insertBefore(this.overlay, this);
    document.body.classList.add('overflow-hidden');

    this.overlay.onclick = this.close;
  }

  close(e) {
    e.stopPropagation();
    this.classList.add(this.translateClass);
    this.overlay.remove();
    this.menu?.forEach((menu)=>{
      menu.classList.add(this.translateClass);
    })
    document.body.classList.remove('overflow-hidden');
    
  }

}